import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconChevronRight.tsx
const OutlinedFilledChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z" })
});
const OutlinedChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z" })
});
const RoundedFilledChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 341-646q-14-14-13.5-33t14.5-33q14-14 33.5-14t33.5 14l197 197q7 7 11 16t4 18q0 9-4 18t-11 16L408-249q-14 14-33 13.5T342-250q-14-14-14-33.5t14-33.5l164-164Z" })
});
const RoundedChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 341-646q-14-14-13.5-33t14.5-33q14-14 33.5-14t33.5 14l197 197q7 7 11 16t4 18q0 9-4 18t-11 16L408-249q-14 14-33 13.5T342-250q-14-14-14-33.5t14-33.5l164-164Z" })
});
const SharpFilledChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z" })
});
const SharpChevronRight = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z" })
});
const componentMap = {
	outlined: OutlinedChevronRight,
	"outlined-fill": OutlinedFilledChevronRight,
	rounded: RoundedChevronRight,
	"rounded-fill": RoundedFilledChevronRight,
	sharp: SharpChevronRight,
	"sharp-fill": SharpFilledChevronRight
};
const IconChevronRight = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconChevronRight };